import React, { useState } from "react";
import { FaClipboardList } from "react-icons/fa";
import PageHeader from "../../../core/common/header/PageHeader";
import AdminClassTestAssignments from "../../admin/classtest/AdminClassTestAssignments";
import AdminClassTestGrade from "../../admin/classtest/AdminClassTestGrade";
import AdminClassTestOverview from "../../admin/classtest/AdminClassTestOverview";

const MENTOR_API = `${process.env.REACT_APP_API_BASE_URL}/api/mentor/class-tests`;

type View = "assignments" | "grade" | "overview";

const MentorClassTestManagement: React.FC = () => {
  const [view, setView] = useState<View>("assignments");
  const [gradingAssignmentId, setGradingAssignmentId] = useState<number | null>(null);

  const openGrade = (assignmentId: number) => {
    setGradingAssignmentId(assignmentId);
    setView("grade");
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <PageHeader
        icon={<FaClipboardList />}
        title="Class Test Management"
        breadcrumb={[
          { label: "Home", to: "/" },
          { label: "Dashboard", to: "/mentor/dashboard" },
          { label: "Class Tests" },
        ]}
      />

      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
        {view !== "grade" && (
          <div className="bg-white rounded-lg shadow-sm mb-6 border border-gray-200">
            <div className="flex border-b border-gray-200">
              {(["assignments", "overview"] as const).map((v) => (
                <button
                  key={v}
                  onClick={() => setView(v)}
                  className={`px-6 py-4 font-medium transition-colors capitalize ${
                    view === v
                      ? "text-[#009fe3] border-b-2 border-[#009fe3] bg-blue-50"
                      : "text-gray-600 hover:text-gray-800 hover:bg-gray-50"
                  }`}
                >
                  {v === "assignments" ? "Assignments" : "Score Overview"}
                </button>
              ))}
            </div>
          </div>
        )}
        {view === "assignments" && (
          <AdminClassTestAssignments onGrade={openGrade} apiBase={MENTOR_API} />
        )}
        {view === "grade" && gradingAssignmentId && (
          <AdminClassTestGrade
            assignmentId={gradingAssignmentId}
            onBack={() => setView("assignments")}
            apiBase={MENTOR_API}
          />
        )}
        {view === "overview" && <AdminClassTestOverview apiBase={MENTOR_API} />}
      </main>
    </div>
  );
};

export default MentorClassTestManagement;
